












import { Component, Watch, Vue } from 'vue-property-decorator';
import { State, Getter, Mutation} from 'vuex-class';
import { FunctionsState } from '../stores/functions/types';
import { Functions, Function, Post } from '../Classes/Entities';
import { PostFactory } from '../Classes/Entities/Chat/PostFactory';
import firebase, { firestore } from 'firebase';
import {FirebaseConnection, Config, Authentications} from '../Classes/Infrastractures';
import Task from '../components/top/Task.vue';
import Announcement from '../components/top/Announcement.vue';
import Note from '../components/top/Note.vue';
import Consultation from '../components/top/Consultation.vue';
import {DataUpdateUsecase} from '../Classes/Usecases';
import router from '../router';
import { PostList } from '../Classes/Entities/Chat/PostList';

const namespace: string = 'functions';

@Component({
  components: {
    Task,
    Announcement,
    Note,
    Consultation
  },
})
export default class Home extends Vue {
  @State('functions') 
  public functions!: FunctionsState;

  @Getter('functionMap', { namespace }) 
  public functionMap!: Functions;

  public get announcement():Function<Post> {
    return this.functionMap.announcement;
  }
  public get note():Function<Post> {
    return this.functionMap.note;
  }
  public get consultation():Function<Post> {
    return this.functionMap.consultation;
  }
  public get task():Function<Post> {
    return this.functionMap.task;
  }
  public get talk():Function<Post> {
    return this.functionMap.talk;
  }

  public created() {
    const connection = new FirebaseConnection(firebase);
    const dataUpdateUsecase = new DataUpdateUsecase(firebase, connection, this.functionMap);
    const self = this;
    dataUpdateUsecase.update((postList:PostList<Post>, post: Function<Post> | Post) => {
      self.$set(postList.threadList, post.id, post);
    })
  }

  public addTask() {
    this.$set(this.task.postList.threadList, (new Date()).toString(), {
      id: (new Date()).toString(),
      title: (new Date()).toString() + 'test',
      username :'佐藤',
      content: 'aaaaa',
      timestamp: new Date(),
    });
  }
}
